import { render, staticRenderFns } from "./pointTask.vue?vue&type=template&id=628e42ec&"
import script from "./pointTask.vue?vue&type=script&lang=js&"
export * from "./pointTask.vue?vue&type=script&lang=js&"
import style0 from "./pointTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports